import React from 'react';
import { AnalyticsContentWrapper } from '../AnalyticsContent/AnalyticsContent.style';
import KpiCardsContainer from '../KpiCardsContainer/KpiCardsContainer';
import { HomeWidgetTitle, HomeWidgetButton, HomeWidgetHeaderGrid } from './HomeWidget.style';
import { generatePath } from 'react-router';
import { appHeaderActions } from 'src/containers/AppHeader/Actions';
import { PermittedRouteMap } from 'src/app-routes';
import { Dispatch } from 'src/components-dummy/types';

interface HomeWidgetProps {
  shopId: number;
  dispatch: Dispatch;
  permittedRouteMap: PermittedRouteMap;
}

export const HomeWidget = ({ shopId, dispatch, permittedRouteMap }: HomeWidgetProps) => {
  const analyticsRoute = permittedRouteMap.analytics?.path;
  const handleViewMore = () => {
    if (analyticsRoute) {
      const path = generatePath(analyticsRoute, { shopId });
      dispatch(appHeaderActions.navigateTo({ navigateTo: path }));
    }
  };

  return (
    <AnalyticsContentWrapper style={{ marginTop: '30px' }}>
      <HomeWidgetHeaderGrid container>
        <HomeWidgetTitle>Syte by the Numbers</HomeWidgetTitle>
        {analyticsRoute && (
          <HomeWidgetButton variant='outlined' onClick={handleViewMore}>
            View more
          </HomeWidgetButton>
        )}
      </HomeWidgetHeaderGrid>
      <KpiCardsContainer key={shopId} shopId={shopId} />
    </AnalyticsContentWrapper>
  );
};
